import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RewardsProgramsGuard } from './rewards-program/guards/rewards-programs-guard.service';
import { routes } from './route-config';

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'disabled',
      initialNavigation: 'disabled',
    }),
  ],
  exports: [RouterModule],
  providers: [RewardsProgramsGuard],
})
export class AppRoutingModule {}
